/**
 * PackagesColumn Component
 * Displays document packages with downloadable items
 *
 * @param {Object} props
 * @param {Array} props.packages - Array of package objects
 * @param {Set} props.downloadingItems - Set of item IDs currently being downloaded
 * @param {Function} props.onDownload - Handler for downloading an item
 * @param {number} props.maxItems - Maximum items to display per package (optional, defaults to showing all)
 */
const PackagesColumn = ({
  packages = [],
  downloadingItems = new Set(),
  onDownload,
  maxItems = null,
}) => {
  if (packages.length === 0) {
    return <span className="approval-summary-td-content">—</span>
  }

  return (
    <div className="as-table-cell-scroll">
      {packages.map((pkg, idx) => (
        <div key={pkg.id || idx}>
          {pkg.items && pkg.items.length > 0 && (
            <div className="as-package-items">
              {(maxItems ? pkg.items.slice(0, maxItems) : pkg.items).map((item, itemIdx) => {
                const itemKey = item.id || item.urn || `pkg-item-${pkg.id}-${itemIdx}`
                const isDownloading = downloadingItems.has(itemKey)

                return (
                  <div
                    key={itemKey}
                    className="as-attachment-compact"
                  >
                    <span className="as-package-item-name" title={item.name}>
                      {item.name || 'Unnamed document'}
                    </span>
                    <button
                      onClick={(e) => onDownload && onDownload(item, e)}
                      disabled={isDownloading}
                      className="as-download-icon-btn"
                      title="Download"
                    >
                      {isDownloading ? '⏳' : '⬇'}
                    </button>
                  </div>
                )
              })}
              {maxItems && pkg.items.length > maxItems && (
                <div style={{
                  fontSize: '0.7rem',
                  color: '#94a3b8',
                  fontStyle: 'italic',
                  paddingLeft: '4px'
                }}>
                  +{pkg.items.length - maxItems} more
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default PackagesColumn
